import type { IconNode } from '../types';

/**
 * @name stairs-arrow-down-left
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTIgMi05IDkiIC8+CiAgPHBhdGggZD0iTTMgN3Y0aDQiIC8+CiAgPHBhdGggZD0iTTIgMjBoNXYtNWg1di01aDVWNWg1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/stairs-arrow-down-left
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const stairsArrowDownLeft: IconNode = [
  ['path', { d: 'm12 2-9 9', key: '10mx2v' }],
  ['path', { d: 'M3 7v4h4', key: '1iq9td' }],
  ['path', { d: 'M2 20h5v-5h5v-5h5V5h5', key: '13vrqq' }],
];

export default stairsArrowDownLeft;
